import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=02b6d340&scoped=true&"
import script from "./AddressView.vue?vue&type=script&lang=js&"
export * from "./AddressView.vue?vue&type=script&lang=js&"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=02b6d340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6d340",
  null
  
)

export default component.exports